import { render, staticRenderFns } from "./prefixIcon-editor.vue?vue&type=template&id=168fcf74&scoped=true&"
import script from "./prefixIcon-editor.vue?vue&type=script&lang=js&"
export * from "./prefixIcon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fcf74",
  null
  
)

export default component.exports